module.exports = __webpack_public_path__ + "img/the-netherlands-mental-and-behavioural-disorders-male.0c26dc48.png";